import { render, staticRenderFns } from "./ShowMetadataProfiles.vue?vue&type=template&id=2c8f445c&scoped=true"
import script from "./ShowMetadataProfiles.vue?vue&type=script&lang=js"
export * from "./ShowMetadataProfiles.vue?vue&type=script&lang=js"
import style0 from "./ShowMetadataProfiles.vue?vue&type=style&index=0&id=2c8f445c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f445c",
  null
  
)

export default component.exports